import { render, staticRenderFns } from "./EventsReport.vue?vue&type=template&id=4a7115a6"
import script from "./EventsReport.vue?vue&type=script&lang=js"
export * from "./EventsReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports